import * as React from "react"

import { formatDate } from "@ui-seeker/utils"
import { Box } from "@mui/material";

import { IconDataBlock } from "@components";


export default function positionColumn() {
    return {
        name: 'verticalPosition',
        label: 'Position',
        options: {
            customBodyRowRender: (value, row) => {
                return <Box sx={{textAlign: 'center'}}>
                    <IconDataBlock value={ value } icon="up-down" />
                    <IconDataBlock value={ row?.horizontalPosition } icon="left-right" />
                </Box>
            }
        }
    }
}